<template>
    <v-layout class="d-block px-1 mt-10">
        <v-row xs3 class="d-flex align-center mb-5" no-gutters>
            <h3 class="ma-0">Today</h3>
            <v-tooltip top>
                <template v-slot:activator="{ on }">
                    <p style="margin-left: 10px; margin-bottom: 0"><v-icon color="grey" dark v-on="on">mdi-information</v-icon></p>
                </template>
                <p class="tooltip-fixed">Opening or closing a unit today may remove or generate tasks as soon as you hit SAVE.</p>
            </v-tooltip>
        </v-row>
        <v-row class="mt-4" no-gutters v-if="openingDaysOverride.length > 0">
            <v-simple-table>
                <template v-slot:default>
                    <thead>
                    <tr>
                        <th class="text-center" colspan="2">Clinic</th>
                        <th class="text-center" colspan="2" v-for="surgery in activeSurgeries" :key="surgery.id">
                            {{surgery.value}}
                        </th>
                        <th></th>
                    </tr>
                    <tr>
                        <th class="text-center" colspan="2">
                            <div class="d-flex justify-space-between">
                                <div class="px-2">AM</div>
                                <div class="px-2">PM</div>
                            </div>
                        </th>
                        <th class="text-center" colspan="2" v-for="(surgery, i) in activeSurgeries" :key="i">
                            <div class="d-flex justify-space-between">
                                <div class="px-2">AM</div>
                                <div class="px-2">PM</div>
                            </div>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr :class="overrideData.isNew ? 'green lighten-5' : ''">
                        <td class="text-center" colspan="2">
                            <div class="d-flex justify-space-between">
                                <action-btn v-if="overrideData.clinic.am" v-on:change="dayClickHandler('clinic', 'am')" :isOpen="overrideData.clinic.am.isOpen" :isChanged="overrideData.clinic.am.changed"></action-btn>
                                <action-btn v-else :noData="true" v-on:change="overrideClinicNoneHandler(overrideData.clinic, overrideData.date, 'am')"></action-btn>
                                <action-btn v-if="overrideData.clinic.pm" v-on:change="dayClickHandler('clinic', 'pm')" :isOpen="overrideData.clinic.pm.isOpen" :isChanged="overrideData.clinic.pm.changed"></action-btn>
                                <action-btn v-else :noData="true" v-on:change="overrideClinicNoneHandler(overrideData.clinic, overrideData.date, 'pm')"></action-btn>
                            </div>
                        </td>
                            <td class="text-center" colspan="2" v-for="surgery in activeSurgeries" :key="surgery.id">
                                <div class="d-flex justify-space-between">
                                    <action-btn v-if="getCorrectSurgery(surgery).am" v-on:change="dayClickHandler('surgery', 'am', getCorrectSurgery(surgery).id)" :isOpen="getCorrectSurgery(surgery).am.isOpen" :isChanged="getCorrectSurgery(surgery).am.changed"></action-btn>
                                    <action-btn v-else :noData="true" v-on:change="overrideSurgeryNoneHandler(getCorrectSurgery(surgery), overrideData.date, 'am')"></action-btn>
                                    <action-btn v-if="getCorrectSurgery(surgery).pm" v-on:change="dayClickHandler('surgery', 'pm', getCorrectSurgery(surgery).id)" :isOpen="getCorrectSurgery(surgery).pm.isOpen" :isChanged="getCorrectSurgery(surgery).pm.changed"></action-btn>
                                    <action-btn v-else :noData="true" v-on:change="overrideSurgeryNoneHandler(getCorrectSurgery(surgery), overrideData.date, 'pm')"></action-btn>
                                </div>
                            </td>
                    </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </v-row>
        <v-card class="pa-5 text-center" v-else>
            <b>No data for chosen dates</b>
        </v-card>
    </v-layout>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { getDayName } from '@/common/date'
  import { sortBy } from 'lodash'
  import ActionBtn from './ActionBtn'

  const month = new Date().getMonth()
  const dateFrom = new Date()
  dateFrom.setMonth(month - 1)
  const dateTo = new Date()
  dateTo.setMonth(month + 12)

  const designators = ['am', 'pm']

  export default {
    name: 'DefaultOpeningDays',
    props: ['clinicId', 'surgeries'],
    data: () => ({
      dataLoading: false,
      openingDaysOverride: [],
      dateToDelete: [],
      newOverrideDate: '',
      addDatePickerStatus: false,
      fromDatePickerStatus: false,
      toDatePickerStatus: false,
      newOverrideDateErrorMessages: '',
      dateFrom: dateFrom.toISOString().substr(0, 10),
      dateTo: dateTo.toISOString().substr(0, 10),
      page: 1,
      limit: 10,
      noData: false
    }),
    computed: {
      ...mapGetters(['getTodayClinicOpening', 'getClinicOpeningDefault']),
      pageCount () {
        return Math.ceil(this.openingDaysOverride.length / this.limit)
      },
      overrideData () {
        const start = (this.page - 1) * this.limit
        const end = this.limit * this.page
        return this.openingDaysOverride.concat().slice(start, end)[0]
      },
      activeSurgeries () {
        const activeSurgeries = Object.keys(this.overrideData.surgeries).map(surgeryId => {
          return this.$store.getters.getSurgeryById(this.clinicId, surgeryId)
        })
        return sortBy(activeSurgeries, 'value')
      }
    },
    methods: {
      ...mapActions(['updateClinicOverrideDays', 'fetchTodayOverrideDays', 'deleteClinicOverrides']),
      getCorrectSurgery (surgery) {
        const key = Object.keys(this.overrideData.surgeries).find(item => Number(item) === surgery.id)
        return this.overrideData.surgeries[key]
      },
      dayClickHandler (type, designator, surgeryId) {
        if (type === 'clinic') {
          this.overrideData[type][designator].isOpen = !this.overrideData[type][designator].isOpen
          if (!this.overrideData[type][designator].isOpen) {
            Object.values(this.overrideData.surgeries).forEach(surgery => {
              surgery[designator].isOpen = this.overrideData[type][designator].isOpen
              surgery[designator].changed = true
            })
          }
          this.overrideData[type][designator].changed = true
        } else {
          const item = this.overrideData.surgeries[surgeryId][designator]
          item.isOpen = !item.isOpen
          if (item.isOpen) {
            this.overrideData.clinic[designator].isOpen = item.isOpen
            this.overrideData.clinic[designator].changed = true
          }
          item.changed = true
        }
        if (this.noData) {
          this.overrideData.isNew = true
        }
      },
      async filterOverrideDays () {
        this.fetchOverrideData()
      },
      async fetchOverrideData () {
        this.dataLoading = true
        await this.fetchTodayOverrideDays({
          clinicId: this.clinicId
        })
        this.createOverrideData()
        this.dataLoading = false
      },
      async createOverrideData (results = [], surgeries = this.surgeries) {
        results = this.getTodayClinicOpening()
        this.openingDaysOverride = results.map(today => {
          const opDataItem = {}
          const clinicInfo = {
            am: results.find((today) => {
              return !today.surgeryId && today.designator.toLowerCase() === 'am'
            }),
            pm: results.find((today) => {
              return !today.surgeryId && today.designator.toLowerCase() === 'pm'
            })
          }
          const surgeriesInfo = surgeries.reduce((acc, surgery) => {
            acc[surgery.id] = {
              am: results.find((today) => {
                return today.surgeryId === surgery.id && today.designator.toLowerCase() === 'am'
              }),
              pm: results.find((today) => {
                return today.surgeryId === surgery.id && today.designator.toLowerCase() === 'pm'
              }),
              id: surgery.id
            }
            return acc
          }, {})

          opDataItem.uuid = this.$uuid.v1()
          opDataItem.clinic = clinicInfo
          opDataItem.surgeries = surgeriesInfo
          return opDataItem
        })
      },
      createOverrideDataItem (date, surgeryId, designator, isOpen = true) {
        return {
          date,
          designator: designator.toUpperCase(),
          clinicId: this.clinicId,
          surgeryId,
          isOpen
        }
      },
      overrideClinicNoneHandler (clinic, date, type) {
        clinic[type] = this.createOverrideDataItem(date, null, type)
        clinic[type].changed = true
      },
      overrideSurgeryNoneHandler (surgery, date, type) {
        surgery[type] = this.createOverrideDataItem(date, surgery.id, type)
        surgery[type].changed = true
      },
      removeOpeningDayOverride (date) {
        this.dateToDelete.push({
          clinicId: this.clinicId,
          date
        })
        this.openingDaysOverride = this.openingDaysOverride.filter(item => item.date !== date)
      },
      addOverride () {
        const newDate = new Date().toISOString().substr(0, 10)
        const newOverride = {
          uuid: this.$uuid.v1(),
          isNew: true,
          date: newDate,
          dayName: getDayName(newDate),
          clinic: {
            am: this.createOverrideDataItem(newDate, null, 'am'),
            pm: this.createOverrideDataItem(newDate, null, 'pm')
          },
          surgeries: this.surgeries.reduce((acc, surgery) => {
            acc[surgery.id] = {
              am: this.createOverrideDataItem(newDate, surgery.id, 'am'),
              pm: this.createOverrideDataItem(newDate, surgery.id, 'pm'),
              id: surgery.id
            }
            return acc
          }, {})
        }
        this.openingDaysOverride.push(newOverride)
        this.page = this.pageCount
      },
      createOverrideFormData () {
        return this.openingDaysOverride.reduce((acc, day) => {
          designators.forEach(designator => {
            const clinicDayPart = day.clinic[designator]
            if (day.isNew || (clinicDayPart && clinicDayPart.changed)) {
              clinicDayPart.clinicId = this.clinicId
              clinicDayPart.surgeryId = null
              clinicDayPart.date = new Date().toISOString().substr(0, 10)
              acc.push(clinicDayPart)
            }
          })
          for (const value of Object.values(day.surgeries)) {
            designators.forEach(designator => {
              const surgeryDayPart = value[designator]
              if (day.isNew || (surgeryDayPart && surgeryDayPart.changed)) {
                surgeryDayPart.surgeryId = value.id
                surgeryDayPart.clinicId = this.clinicId
                surgeryDayPart.date = new Date().toISOString().substr(0, 10)
                acc.push(surgeryDayPart)
              }
            })
          }
          return acc
        }, [])
      },
      async saveOverrideData () {
        const formData = this.createOverrideFormData()
        if (this.dateToDelete.length > 0) {
          this.deleteClinicOverrides({
            days: this.dateToDelete
          })
        }
        if (formData.length > 0) {
          const confirmModalOptions = {
            text: 'You have made changes to unit openings for today. Some Daily and Weekly-on-Day  tasks may be created or deleted after you save. Proceed?',
            agreeBtnText: 'Proceed',
            type: 'info'
          }
          const confirm = await this.$root.$confirmDialog.open('', confirmModalOptions)
          if (!confirm) {
            return
          }
          return this.updateClinicOverrideDays({
            days: formData
          })
        }
        return true
      }
    },
    mounted () {
      // this.addOverride()
    },
    components: {
      ActionBtn
    }
  }
</script>
